import React, { FC, useEffect, useMemo } from 'react';
import View from './view';

import { useBridgeApi, usePrevious, useSelector } from '~Hooks';
import SelectStation from './Components/SelectStation';
import useBongQuery from '~Scenes/POS/Queries/query';

import { useStorage } from '~Components/Storage';
import BongMaster from '~Scenes/Tables/Components/BongMaster';
import useFilterOrders from './Hooks/useFilterOrders';

type Props = {
  venueId: string;
  isModal?: boolean;
};

export type ItemWithCourseType = {
  itemId: string;
  courseId: string;
};

const EventedKitchenDisplay: FC<Props> = ({ venueId, isModal }) => {
  const bridgeApi = useBridgeApi();
  const { loading, progress, progressText, data } = useBongQuery(venueId);
  const [storage] = useStorage();

  /**
   * Get current station
   */
  const station = useSelector((state) => {
    if (!state.stations || !storage.selectedKDSStation) {
      return undefined;
    }

    return state.stations.find((s) => s.id === storage.selectedKDSStation);
  });

  const itemsWithCourseType: ItemWithCourseType[] = useMemo(() => {
    return (
      data?.company.items
        .filter((i) => i.courseType)
        .map((i) => ({
          itemId: i.id,
          courseId: i.courseType.id,
        })) ?? []
    );
  }, [data]);

  let orders = useFilterOrders({ station });
  // Ensure there's no duplicates
  const orderIds = orders.map((o) => o.id);
  orders = orders.filter((order, index) => {
    return orderIds.indexOf(order.id) === index;
  });

  const previousOrdersLength = usePrevious(orders.length);

  useEffect(() => {
    if (previousOrdersLength === undefined) {
      return;
    }

    if (!storage.KDSPlayNewOrderSound) {
      return;
    }

    if (previousOrdersLength < orders.length) {
      bridgeApi.playSound();
    }
  }, [orders.length]);

  return (
    <React.Fragment>
      <View
        venueId={venueId}
        loading={loading}
        progress={progress}
        errors={[]}
        orders={orders}
        itemsWithCourseType={itemsWithCourseType}
        progressText={progressText}
        isModal={isModal}
      />
      <SelectStation />
      {!isModal && <BongMaster />}
    </React.Fragment>
  );
};

export default EventedKitchenDisplay;
